/** Shared password complexity rules for registration and first-login flows. */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS = [
  {
    id: 'minLength',
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: (value) => (value ?? '').length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: 'lowercase',
    label: 'One lowercase letter (a–z)',
    test: (value) => /[a-z]/.test(value ?? ''),
  },
  {
    id: 'uppercase',
    label: 'One uppercase letter (A–Z)',
    test: (value) => /[A-Z]/.test(value ?? ''),
  },
  {
    id: 'digit',
    label: 'One number (0–9)',
    test: (value) => /\d/.test(value ?? ''),
  },
  {
    id: 'special',
    label: 'One special character (e.g. !@#$%^&*)',
    test: (value) => /[^A-Za-z0-9]/.test(value ?? ''),
  },
];

export function evaluatePasswordRequirements(password) {
  return PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    met: requirement.test(password),
  }));
}

export function meetsPasswordComplexity(password) {
  return evaluatePasswordRequirements(password).every((requirement) => requirement.met);
}

/** Yup schema fragment for a complex new password field. */
export function complexPasswordField(yup, options = {}) {
  const { requiredMessage = 'New password is required' } = options;
  return yup
    .string()
    .required(requiredMessage)
    .test(
      'password-complexity',
      'Password must meet all complexity requirements below',
      (value) => meetsPasswordComplexity(value)
    );
}
